module.exports = __webpack_public_path__ + "img/37_158.8dde6df0.png";